export const MuiListSubheader = {
    styleOverrides: {
        root: ({ theme })=>({
                color: theme.palette.text.primary
            })
    }
};

//# sourceMappingURL=list-subheader.js.map